import axios from 'axios'

export const getTransactionHashByTokenId = async ({ token_id }) => {
  const options = {
    method: 'GET',
    url: `https://deep-index.moralis.io/api/v2.2/nft/${process.env.REACT_APP_nft_contract}/${token_id}/transfers`,
    params: {
      chain: process.env.REACT_APP_blockchain_chain,
      format: 'decimal',
      order: 'DESC'
    },
    headers: {
      accept: 'application/json',
      'X-API-Key':
        process.env.REACT_APP_moralis_apiKey,
    },
  }

  return axios
    .request(options)
    .then(function (response) {
      const data = response?.data?.result?.[0]
      return data
    })
    .catch(function (error) {
      console.error(error)
    })
}
